import styles from "./styles.module.scss";
import Button from "components/Button";
import { useAuth, hasAuthParams } from "react-oidc-context";
import { useEffect } from "react";
import React from "react";
import { useTranslation } from "react-i18next";

const Unauthorized = ({ redirect = true }: { redirect?: boolean }) => {
  const { t } = useTranslation();
  const auth = useAuth();
  const [hasTriedSignin, setHasTriedSignin] = React.useState(false);

  useEffect(() => {
    auth
      .querySessionStatus()
      .then((status) => {
        if (!process.env.NODE_ENV || process.env.NODE_ENV === "development") {
          // no-op in development
        } else if (import.meta.env.VITE_APP_HOST_TYPE === "alfa") {
          auth.signinRedirect();
        } else {
          if (
            !hasAuthParams() &&
            !auth.isAuthenticated &&
            !auth.activeNavigator &&
            !auth.isLoading &&
            !hasTriedSignin
          ) {
            auth.signinRedirect();
            setHasTriedSignin(true);
          }
        }
      })
      .catch((r) => {
        if (!process.env.NODE_ENV || process.env.NODE_ENV === "development") {
          // no-op in development
        } else if (import.meta.env.VITE_APP_HOST_TYPE === "alfa") {
          auth.signinRedirect();
        } else {
          if (redirect) {
            window.location.replace(import.meta.env.VITE_APP_SITE + "/home");
          }
        }
      });
  });

  return (
    <div className={styles.wrapper}>
      <div className={styles.content}>
        <div className={styles.text}>{t("auth.notLoggedIn")}</div>
        <Button text={t("auth.signIn")} onClick={() => auth.signinRedirect()}></Button>
      </div>
    </div>
  );
};

export default Unauthorized;
